import React from 'react';
import './Button.css';

function Button({ 
  children, 
  variant = 'primary', 
  onClick, 
  type = 'button',
  disabled = false,
  showArrow = false,
  arrowDirection = 'right', // 'right' or 'down'
  className = ''
}) {
  const arrowSymbol = arrowDirection === 'down' ? '↓' : '→';
  const arrowClass = arrowDirection === 'down' ? 'btn-arrow-down' : 'btn-arrow-right';
  
  return (
    <button
      type={type}
      className={`btn btn-${variant} ${showArrow ? 'btn-with-arrow' : ''} ${className}`}
      onClick={onClick}
      disabled={disabled}
    >
      {showArrow ? (
        <>
          <span className="btn-text">{children}</span>
          <span className={`btn-arrow ${arrowClass}`}>{arrowSymbol}</span>
        </>
      ) : (
        <span className="btn-text">{children}</span>
      )}
    </button>
  );
}

export default Button;






